"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLOBAL_DISCLAIMER_STORE_WINDOW_KEY = '__ksysGlobalDisclaimerStore__';